import React, { useContext } from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import { EPCRContext } from '../EPCR'

const Reported = ({ formValues }) => {
  const { handleChange } = useContext(EPCRContext)
  const cadLocked = !!formValues?.incident?.cadIncident
  return (
    <>
      <Grid item xs={12} lg={4} display="flex" gap={2} flexDirection="column">
        <Box display="flex">
          <FormControl fullWidth>
            <Autocomplete
              options={[
                'Event Organiser',
                'Event Control',
                'Patient / Self',
                'Public',
                'Security',
                'Ambulance',
                'Police',
                'Fire',
                'Self Mobilised',
                'Other',
              ]}
              freeSolo
              onChange={(e, newValue) => {
                handleChange({
                  moduleName: 'incident',
                  field: 'reportedBy',
                  value: newValue,
                })
              }}
              onBlurCapture={(e) =>
                handleChange({
                  moduleName: 'incident',
                  field: 'reportedBy',
                  value: e.target.value,
                })
              }
              name="reportedBy"
              value={formValues?.incident?.reportedBy ?? ''}
              disabled={cadLocked}
              renderInput={(params) => (
                <TextField {...params} label="Reported By" name="reportedBy" />
              )}
            />
          </FormControl>
        </Box>
      </Grid>
      <Grid item xs={12} lg={4}>
        <Box display="flex" flex={1}>
          <TextField
            fullWidth
            value={formValues?.incident?.reportedComplaint ?? ''}
            disabled={cadLocked}
            onChange={(e) =>
              handleChange({
                moduleName: 'incident',
                field: 'reportedComplaint',
                value: e.target.value,
              })
            }
            label="Reported Injury or Illness"
            multiline
          />
        </Box>
      </Grid>
    </>
  )
}

export default Reported
